<template>
  <div class="p-m-auto" style="width:80%; height:100%;">
    <div>
      <div class="p-mb-1">
        <span>{{ __("Date of operation") }}:</span>
        <span class="service-call-data">{{ data.TRValueDate }}</span>
      </div>
      <div class="p-mb-1">
        <span>{{ __("Supplier") }}:</span>
        <span class="service-call-data">{{ data.Company }}</span>
      </div>
      <div class="p-mb-1">
        <span>{{ __("Sum") }}:</span>
        <span class="service-call-data">{{ data.TRValue }}</span>
      </div>
      <div class="p-mb-1">
        <span>{{ __("Purpose") }}:</span>
        <span class="service-call-data">{{ data.TRPurpose }}</span>
      </div>
    </div>
    <div>
      <div class="p-my-4" v-if="data.Items.length > 0">
        <div class="table-title item">
          <span>{{ __("Item") }}</span>
          <span>{{ __("Count") }}</span>
        </div>
        <div v-for="(item, index) of data.Items" :key="index" class="item">
          <span>{{ item.ItemName }}</span>
          <span class="service-call-data">{{ item.Qty }}</span>
        </div>
      </div>
      <div class="p-mb-1">
        <span>{{ __("Total cost") }}:</span>
        <span class="service-call-data">{{ data.TRValue }}</span>
      </div>
      <div class="p-mb-1" v-if="data.PaymentTypeName">
        <span>{{ __("Payment methods") }}:</span>
        <span class="service-call-data">{{ data.PaymentTypeName }}</span>
      </div>
      <div class="p-mb-1" v-if="data.TRChequeDate">
        <span>{{ __("Cheque Date") }}:</span>
        <span class="service-call-data">{{
          dateFormat(data.TRChequeDate, false, false, true)
        }}</span>
      </div>
      <div class="p-mb-1" v-if="data.TRBank">
        <span>{{ __("Bank") }}:</span>
        <span class="service-call-data">{{ data.TRBank }}</span>
      </div>
      <div class="p-mb-1" v-if="data.TRBranch">
        <span>{{ __("Branch") }}:</span>
        <span class="service-call-data">{{ data.TRBranch }}</span>
      </div>
      <div class="p-mb-1" v-if="data.TRAccount">
        <span>{{ __("Account") }}:</span>
        <span class="service-call-data">{{ data.TRAccount }}</span>
      </div>
      <div class="p-d-flex">
        <div class="p-mb-1">
          <span>{{ __("special edition") }}:</span>
          <p-vue-radio
            class="p-mx-2"
            id="my-problems"
            name="problems"
            value="0"
            disabled="true"
            v-model="TRNormalExpense"
          />
        </div>
        <div class="p-mb-1 p-mr-4">
          <span>{{ __("שוטף") }}:</span>
          <p-vue-radio
            class="p-mx-2"
            id="my-problems"
            name="problems"
            value="1"
            disabled="true"
            v-model="TRNormalExpense"
          />
        </div>
      </div>
      <div class="p-mb-1">
        <span>{{ __("Paid by us for the building") }}:</span>
        <p-vue-checkbox
          class="p-mx-2"
          :binary="true"
          v-model="PayedByCompany"
          disabled="true"
        />
      </div>
      <div class="p-mb-1" v-if="data.invoiceNum">
        <span>{{ __("Invoice num") }}:</span>
        <span class="service-call-data">{{ data.invoiceNum }}</span>
      </div>
      <div class="p-mb-1" v-if="data.TRRef">
        <span>{{ __("Reference") }}:</span>
        <span class="service-call-data">{{ data.TRRef }}</span>
      </div>
      <div class="p-mb-1">
        <span>{{ __("Company share") }}:</span>
        <span class="service-call-data">{{ data.TRCompanyShare }}</span>
      </div>
      <div class="p-mb-1">
        <span>{{ __("supplier commision") }}:</span>
        <span class="service-call-data">{{ data.TRSupplierCommission }}</span>
      </div>
      <div class="p-mb-1" v-if="data.TRNotes">
        <span>{{ __("Remarks") }}:</span>
        <span class="service-call-data">{{ data.TRNotes }}</span>
      </div>
    </div>
  </div>
  <!-- <div class="p-d-flex p-jc-end" style="gap: 10px;">
    <p-vue-button
      icon="pi pi-pencil"
      class="p-button-rounded p-button-success p-button-outlined"
      @click="showModal = true"
    />
    <p-vue-button
      icon="pi pi-trash"
      class="p-button-rounded p-button-danger p-button-outlined"
      @click="deleteMoney"
    />
  </div> -->
  <i-override-dialog
    v-model:visible="showModal"
    :style="{
      width: '100%',
      maxWidth: 'calc(100vw - 10px)',
    }"
    :modal="true"
    :dismissableMask="true"
    :title="__(addModelTitle) + ' ' + __('Expenses')"
  >
    <local-add-money
      :money="data"
      @moneyChanged="moneyChanged"
      :close="
        () => {
          showModal = false;
        }
      "
    ></local-add-money>
  </i-override-dialog>
</template>

<script>
import { callProc, apiParam, apiPType } from "@/services/APointAPI";
import { dateFormat } from "@/services/apointUtil";
import LocalAddMoney from "./add-money";
import { errorReceived, showSuccessOrFailedModal } from "@/services/apointUtil";
import { __ } from "@/plugins/i18n";

export default {
  components: {
    LocalAddMoney,
  },
  props: {
    data: {
      type: Object,
    },
  },
  emits: ["reload"],
  data() {
    return {
      dateFormat,
      showModal: false,
      TRNormalExpense: "0",
      PayedByCompany: false,
      addModelTitle: "Edit a",
    };
  },
  mounted() {
    this.TRNormalExpense = this.data.TRNormalExpense ? "1" : "0";
    this.PayedByCompany = this.data.PayedByCompany;
  },
  methods: {
    deleteMoneyInDB() {
      this.$store.dispatch("doLoading", true);
      let procParams = [apiParam("TRID", this.data.TRID, apiPType.Int)];
      callProc("WorkerApp_DeleteMoneyOfProblems", procParams)
        .then((result) => {
          result = JSON.parse(result);
          // console.log("WorkerApp_DeleteMoneyOfProblems", result);
          if (result.procReturnValue == 0) {
            showSuccessOrFailedModal(
              __("The expense was successfully deleted")
            );
            setTimeout(() => {
              this.$emit("reload", "WorkerApp_GetMoneyToServiceCall", false);
            }, 1000);
          } else {
            showSuccessOrFailedModal(__(result.Table[0].desc), false);
          }
          this.$store.dispatch("doLoading", false);
        })
        .catch(() => {
          errorReceived("WorkerApp_DeleteMoneyOfProblems");
        });
    },
    moneyChanged(reload) {
      this.showModal = false;
      this.$emit("reload", "WorkerApp_GetMoneyToServiceCall", reload);
    },
  },
  computed: {
    Delete() {
      return this.data.Delete;
    },
    IsEdit() {
      return this.data.IsEdit;
    },
  },
  watch: {
    Delete() {
      if (this.Delete) this.deleteMoneyInDB();
    },
    IsEdit() {
      if (this.IsEdit) this.showModal = true;
    },
  },
};
</script>

<style scoped>
.service-call-data {
  color: var(--color-accent);
  margin: 0 0.5rem;
}

:deep(.svg) {
  color: var(--color-success);
  width: 18px;
  height: 18px;
}

.rotate {
  transform: rotate(180deg);
}

.item {
  display: grid;
  grid-template-columns: 50% 50%;
}

.table-title {
  font-weight: 600;
}
</style>
